if (!customElements.get("sticky-atc")) {
  customElements.define(
    "sticky-atc",
    class StickyAtc extends HTMLElement {
      connectedCallback() {
        this.container = this.closest(".m-sticky-addtocart");
        this.button = this.querySelector(".silix-sticky-atc__button");
        this.observeTarget = document.querySelector(".m-product-form--wrapper") || document.querySelector(".m-main-product--info");

        if (!this.container || !this.button) return;

        this.button.addEventListener("click", this.scrollToPurchaseOptions.bind(this));
        this.setStickyAddToCartHeight();
        this.initVisibilityObserver();

        document.addEventListener("matchMobile", () => this.setStickyAddToCartHeight());
        document.addEventListener("unmatchMobile", () => this.setStickyAddToCartHeight());
        window.addEventListener("resize", () => this.setStickyAddToCartHeight(), { passive: true });
      }

      getScrollTarget() {
        const selectors = [
          ".rapi-bundle-content",
          "[class*='rapi-bundle']",
          "[id*='rapi']",
          "[class*='rapi']",
          ".m-product-form--wrapper"
        ];

        for (const selector of selectors) {
          const candidates = document.querySelectorAll(selector);
          for (const candidate of candidates) {
            const rect = candidate.getBoundingClientRect();
            if (rect.width > 0 && rect.height > 0) return candidate;
          }
        }

        return document.querySelector(".m-product-form--wrapper") || document.querySelector(".m-main-product--info");
      }

      scrollToPurchaseOptions() {
        const target = this.getScrollTarget();
        if (!target) return;

        const headerHeight = window.MinimogSettings?.headerHeight || 66;
        const targetTop = target.getBoundingClientRect().top + window.pageYOffset;
        const offset = headerHeight + 16;

        window.scrollTo({
          top: Math.max(targetTop - offset, 0),
          behavior: "smooth"
        });
      }

      initVisibilityObserver() {
        if (!this.observeTarget || !("IntersectionObserver" in window)) {
          this.container.classList.add("sticky-show");
          return;
        }

        const updateVisibility = (entry) => {
          const hasScrolledPastTarget = entry.boundingClientRect.top < 0;
          const shouldShow = !entry.isIntersecting && hasScrolledPastTarget;
          this.container.classList.toggle("sticky-show", shouldShow);
          this.setStickyAddToCartHeight();
        };

        this.observer = new IntersectionObserver((entries) => {
          entries.forEach(updateVisibility);
        }, {
          root: null,
          threshold: 0
        });

        this.observer.observe(this.observeTarget);
      }

      setStickyAddToCartHeight() {
        const height = this.container.classList.contains("sticky-show") ? this.container.offsetHeight : 0;
        document.documentElement.style.setProperty("--f-sticky-atc-bar-height", `${height}px`);
        window.MinimogSettings = window.MinimogSettings || {};
        window.MinimogSettings.stickyAddToCartHeight = height;
      }
    }
  );
}
